module.exports = __webpack_public_path__ + "11192222381011cc9e57755fb0406c48.png";